<!-- <template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" class="mb-3">
        <product-sliders v-tracker="'home-banner'" />
      </b-col>

      <b-col>
        <b-row>
          <b-col cols="12" lg="9">
            <div>
              <h3 class="mb-1">Product By Portfolio</h3>
              <product-by-unit-cards />
            </div>

            <div class="mt-2">
              <h3 class="mb-1">Product By CFU</h3>
              <product-by-cfu-cards />
            </div>

            <div class="mt-2">
              <h3 class="mb-1">Latest News</h3>
              <news-cards-home :news="news" />
              <div class="d-flex justify-content-start" v-if="totalNews > 6">
                <b-button v-tracker="'button:view-all-news'" :to="{ name: 'all-news' }" variant="primary">
                  View All News
                </b-button>
              </div>
            </div>
          </b-col>

          <b-col lg="3">
            <div class="mb-3">
              <h3 class="mb-3">Customer Service</h3>
              <div>
                <div class="mb-2">
                  <router-link v-tracker="'button:contact-us'" :to="{ name: 'contact-us' }">
                    <span class="mr-1 text-white rounded p-50 bg-primary">
                      <feather-icon icon="PhoneIcon" />
                    </span>
                    <span class="text-body">Contact Us</span>
                  </router-link>
                </div>
                <div v-tracker="'button:tou'" v-b-modal="tosModalId" class="mb-2">
                  <span class="mr-1 text-white rounded p-50 bg-primary">
                    <feather-icon icon="FileTextIcon" />
                  </span>
                  <span>Terms of Use</span>
                </div>
                <div>
                  <a v-tracker="'button:guidance'" style="color:#6e6b7b" :href="`${publicPath}/docs/handbook.pdf`"
                      target="_blank">
                    <span class="mr-1 text-white rounded p-50 bg-primary">
                      <feather-icon icon="BookIcon" />
                    </span>
                    <span>Guidance</span>
                  </a>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <h3 class="mb-1">Other Site</h3>
              <div>
                <a v-tracker="'button:other-site:imove'" :href="'https://imove.telkom.co.id/newimove/'" target="_blank" style="color:#6e6b7b;">
                <span class="mr-1 text-white rounded p-50 bg-primary">
                  <feather-icon icon="GlobeIcon" />
                </span>
                <span>iMove</span>
                </a>
              </div>
            </div>

            <b-card bg-variant="primary" text-variant="white">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <span class="mr-1 pb-50">
                    <feather-icon icon="StarIcon" />
                  </span>
                  <h4 class="text-white">NPS Rate</h4>
                </div>
                <h1 class="text-white font-weight-bolder"> {{ rating_result }} </h1>
              </div>
            </b-card>

            <div class="mt-3">
              <h3 class="mb-1">Download App</h3>
              <b-card>
                <b-card-text style="font-size:0.7rem">
                  Get Mobile Version Here for <strong>Android & iOS</strong>
                </b-card-text>
                <b-button
                  v-tracker="'button:download'"
                  :href="weblink"
                  target="_blank"
                  block
                  variant="primary"
                  >Download Link</b-button
                >
              </b-card>
            </div>

            <visitor-card />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <tos-modal :id="tosModalId" />
  </b-container>
</template>

<script>
import ProductSliders from '@/views/user/home/ProductSliders.vue'
import TermsOfUseModal from '@/views/user/home/TermsOfUseModal.vue'
import VisitorCard from '@/views/user/home/VisitorCard.vue'
import ProductByUnitCards from '@/views/user/home/ProductByUnitCards.vue'
import ProductByCFUCards from '@/views/user/home/ProductByCFUCards.vue'
import {
  VBModal,
  BContainer,
  BRow,
  BCol,
  BButton,
  BCard,
  BCardText,
  BModal,
  BFormRating,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import Ripple from 'vue-ripple-directive'
import NewsCardsHome from './news/NewsCardsHome.vue'

export default {
  components: {
    ProductSliders,
    TosModal: TermsOfUseModal,
    BContainer,
    BRow,
    BCol,
    BButton,
    FeatherIcon,
    BCard,
    BCardText,
    BModal,
    BFormRating,
    VisitorCard,
    ProductByUnitCards,
    ProductByCfuCards: ProductByCFUCards,
    NewsCardsHome,
  },

  directives: {
    VBModal,
    Ripple,
  },

  data() {
    return {
      tosModalId: 'tos-modal',
      publicPath: process.env.VUE_APP_API_HOST,
      news: [],
      totalNews: 0,
      weblink: '',
      rating_val: null,
      rating_result: 0,
    }
  },

  mounted() {
    this.getResultNPS()
    this.fetchNews()
    this.fetchSettings()
  },

  methods: {
    fetchNews() {
      this.$http.get('/browse-news').then(({ data }) => {
        this.news = data.data
        this.totalNews = data.total
      })
    },
    fetchSettings() {
      this.$http
        .get('/settings/apps-link')
        .then(res => {
          this.weblink = res.data.data.web_link
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },
    toImove(){
      window.location.href()
    },
    async checkShowNPSRate() {
      return await this.$http.get('/rating/my/check')
      .then((res) => {
        let data = res.data.data.records
        if (data.length < 1) {
          this.$notifOnClick(
          'Rate App!', 
          "You haven't rate this app yet. You can rating this app by click button.", 
          'danger', 
          'AlertTriangleIcon', 
          'danger', 
          'Rate this app', 
          () => {
            try {
              this.showNPS()
            } catch (error) {
              this.$router.push({name: 'home'})
            }
          })
        }
      })
    },
    async getResultNPS() {
      return await this.$http.get("/rating/take/all/case/result")
      .then(res => {
        let data = res.data.data.records
        this.rating_result = data.rate
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
}
</script>

<style scoped>
/deep/ .form-control-lg {
  font-size: 2rem;
}
</style>

<style>
@media only screen and (max-width: 1480px)  {
  .c-text {
    font-size: 0.68rem;
  }
  .c-h4 {
    font-size: 0.95rem;
  }
}

@media only screen and (min-width: 2000px)  {
  .c-text {
    font-size: 1.4rem;
  }
  .c-h4 {
    font-size: 1.5rem;
  }
}
</style> -->

<template>
  <b-container fluid>
    <b-row>
      <b-button
        variant="primary"
        class="contact-button position-fixed shadow d-flex justify-content-center align-items-center"
        @click="navigateToContactUs"
      >
        Hubungi Kami
        <b-img :src=customerService style="width:20px; transform: rotate(-270deg); margin-top: 8px;"></b-img>
      </b-button>
      <b-col cols="12" class="mb-3">
        <product-sliders v-tracker="'home-banner'" />
      </b-col>
    </b-row>
    <b-row>
      <!-- <b-col cols="12">
        <div class="mt-2">
          <h3 class="mb-1">Latest News</h3>
          <news-cards-home :news="news" />
        </div>
      </b-col> -->
      <b-col cols="12">
        <div>
          <h3 class="mb-1">Product By Portfolio</h3>
          <product-by-unit-cards />
        </div>
      </b-col>
      <!-- <b-col md="6">
        <h3 class="mb-1">Product By CFU</h3>
        <product-by-cfu-cards />
      </b-col>
      <b-col md="6">
        <h3 class="mb-1">Latest News</h3>
        <news-cards-home :news="news" />
      </b-col> -->
    </b-row>
    <b-row class="d-flex justify-content-center">
      <b-col md="12" lg="4">
        <h3 class="mb-1">Product By CFU</h3>
        <product-by-cfu-cards />
      </b-col>
      <b-col md="12" lg="8">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-1">Latest News</h3>
          <b-button
            v-if="totalNews > 3"
            v-tracker="'button:view-all-news'"
            :to="{ name: 'all-news' }"
            variant="link"
            class="p-0 text-primary"
          >
            See All
          </b-button>
        </div>
        <news-cards-home :news="news" />
      </b-col>

    </b-row>
    <b-card>
      <b-row class="">
        <b-col cols="12" md="3" class="mb-3">
          <h5 class="font-weight-bold">Customer Service</h5>
          <div class="mt-2">
            <router-link v-tracker="'button:contact-us'" :to="{ name: 'contact-us' }">
              <span class="mr-1 text-white rounded p-50 bg-primary">
                <feather-icon icon="PhoneIcon" />
              </span>
              <span class="text-body">Contact Us</span>
            </router-link>
          </div>
          <div v-tracker="'button:tou'" v-b-modal="tosModalId" class="mt-2">
            <span class="mr-1 text-white rounded p-50 bg-primary">
              <feather-icon icon="FileTextIcon" />
            </span>
            <span>Terms of Use</span>
          </div>
          <div class="mt-2">
            <a v-tracker="'button:guidance'" style="color:#6e6b7b" :href="`${publicPath}/docs/handbook.pdf`"
                target="_blank">
              <span class="mr-1 text-white rounded p-50 bg-primary">
                <feather-icon icon="BookIcon" />
              </span>
              <span>Guidance</span>
            </a>
          </div>
        </b-col>
        <b-col cols="12" md="3" class="mb-3">
          <h5 class="font-weight-bold">Visitor</h5>
          <visitor-card />
        </b-col>
        <b-col cols="12" md="3" class="mb-3">
          <div class="mb-2">
            <h5 class="font-weight-bold">Other Site</h5>
            <div class="mt-1">
              <a v-tracker="'button:other-site:imove'" :href="'https://imove.telkom.co.id/newimove/'" target="_blank" style="color:#6e6b7b;">
              <span class="mr-1 text-white rounded p-50 bg-primary">
                <feather-icon icon="GlobeIcon" />
              </span>
              <span>iMove</span>
              </a>
            </div>
          </div>
          <b-card bg-variant="primary" class="w-75" text-variant="white">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <span class="mr-1 pb-50">
                  <feather-icon icon="StarIcon" />
                </span>
                <h4 class="text-white">NPS Rate</h4>
              </div>
              <h1 class="text-white font-weight-bolder"> {{ rating_result }} </h1>
            </div>
          </b-card>

        </b-col>
        <b-col cols="12" md="3" class="mb-3">
          <h5 class="font-weight-bold">Download App</h5>
          <p class="mb-2" style="font-size: 0.8rem;">Get Mobile Version Here for <strong>Android & iOS</strong></p>
          <b-button
            :href="weblink"
            target="_blank"
            variant="primary"
            size="sm"
            class="w-100"
          >Download Link</b-button>
        </b-col>
      </b-row>
    </b-card>
    <tos-modal :id="tosModalId" />
  </b-container>
</template>

<script>
import ProductSliders from '@/views/user/home/ProductSliders.vue'
import TermsOfUseModal from '@/views/user/home/TermsOfUseModal.vue'
import VisitorCard from '@/views/user/home/VisitorCard.vue'
import ProductByUnitCards from '@/views/user/home/ProductByUnitCards.vue'
import ProductByCFUCards from '@/views/user/home/ProductByCFUCards.vue'
import {
  VBModal,
  BContainer,
  BRow,
  BCol,
  BButton,
  BCard,
  BCardText,
  BModal,
  BFormRating,
  BImg,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import Ripple from 'vue-ripple-directive'
import NewsCardsHome from './news/NewsCardsHome.vue'

export default {
  components: {
    ProductSliders,
    TosModal: TermsOfUseModal,
    BContainer,
    BRow,
    BCol,
    BButton,
    FeatherIcon,
    BCard,
    BCardText,
    BModal,
    BFormRating,
    VisitorCard,
    ProductByUnitCards,
    ProductByCfuCards: ProductByCFUCards,
    NewsCardsHome,
    BImg
  },

  directives: {
    VBModal,
    Ripple,
  },

  data() {
    return {
      customerService: require("@/assets/images/icons/customerService.png"),
      tosModalId: 'tos-modal',
      publicPath: process.env.VUE_APP_API_HOST,
      news: [],
      totalNews: 0,
      weblink: '',
      rating_val: null,
      rating_result: 0,
    }
  },

  mounted() {
    this.getResultNPS()
    this.fetchNews()
    this.fetchSettings()
  },

  methods: {
    navigateToContactUs() {
      this.$router.push({ name: 'contact-us' })
    },
    fetchNews() {
      this.$http.get('/browse-news').then(({ data }) => {
        this.news = data.data.slice(0, 3)
        this.totalNews = data.total
      })
    },
    fetchSettings() {
      this.$http
        .get('/settings/apps-link')
        .then(res => {
          this.weblink = res.data.data.web_link
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },
    toImove(){
      window.location.href()
    },
    async checkShowNPSRate() {
      return await this.$http.get('/rating/my/check')
      .then((res) => {
        let data = res.data.data.records
        if (data.length < 1) {
          this.$notifOnClick(
          'Rate App!', 
          "You haven't rate this app yet. You can rating this app by click button.", 
          'primary', 
          'AlertTriangleIcon', 
          'primary', 
          'Rate this app', 
          () => {
            try {
              this.showNPS()
            } catch (error) {
              this.$router.push({name: 'home'})
            }
          })
        }
      })
    },
    async getResultNPS() {
      return await this.$http.get("/rating/take/all/case/result")
      .then(res => {
        console.log('result nps', res)
        let data = res.data.data.records
        this.rating_result = data.rate
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
}
</script>

<style scoped>
.form-control-lg {
  font-size: 2rem;
}
</style>

<style>
.contact-button {
  width: 40px;
  height: auto;
  right: 0;
  top: 50%;
  position: fixed;
  z-index: 100;
  font-size: 16px;
  letter-spacing: 1px;
  white-space: nowrap;
  text-align: center;
  writing-mode: vertical-lr;
  transform: translateY(-50%) rotate(-180deg);
  transition: transform 0.3s ease-in-out;
}

.contact-button:hover {
  transform: translateY(-50%) rotate(-180deg) scale(1.1);
}

/* Optional: zoom gambar juga */
.customer-img {
  width: 20px;
  margin-top: 8px;
  transform: rotate(-270deg);
  transition: transform 0.3s ease-in-out;
}

@media only screen and (max-width: 1480px)  {
  .c-text {
    font-size: 0.68rem;
  }
  .c-h4 {
    font-size: 0.95rem;
  }
}

@media only screen and (min-width: 2000px)  {
  .c-text {
    font-size: 1.4rem;
  }
  .c-h4 {
    font-size: 1.5rem;
  }
}
</style>